import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';

import { GET, newFetch } from '../../../helpers/fetch';

const RewardsSidebar = ({ activeSidebar, setActiveSidebar, data }) => {
  const tabs = ['Available', 'Expired'];
  //const [pointsLifeCycle, setPoinstLifeCycle] = useState(null);
  const [activeTab, setActiveTab] = useState('Available');
  const [available, setAvailable] = useState([]);
  const [expired, setExpired] = useState([]);
  const [newEarnedPoints, setNewEarnedPoints] = useState([]);

  // const fetchSetting = async () => {
  //   let api_path = `/reward/setting`;
  //   let response = await newFetch(GET, api_path);

  //   if (response.success) setPoinstLifeCycle(response.data.points_life_cycle);
  // };

  useEffect(() => {
    if (data) {
      setNewEarnedPoints(
        data.filter((history) => history.reward_earned_points.length > 0)
      );
    }
  }, [data]);

  useEffect(() => {
    if (newEarnedPoints) {
      // let availableData = data
      //   .filter((history) =>
      //     moment().isSameOrBefore(
      //       moment(history.createdAt).add(pointsLifeCycle, "M")
      //     )
      //   )
      //   .sort((a, b) =>
      //     moment(a.createdAt).isBefore(moment(b.createdAt)) ? 1 : -1
      //   );
      // let expiredData = data
      //   .filter((history) =>
      //     moment().isAfter(moment(history.createdAt).add(pointsLifeCycle, "M"))
      //   )
      //   .sort((a, b) =>
      //     moment(a.createdAt).isAfter(moment(b.createdAt)) ? 1 : -1
      //   );
      // setAvailable(
      //   availableData.map((history) => ({
      //     ...history,
      //     expiry_date: moment(history.createdAt).add(pointsLifeCycle, "M"),
      //   }))
      // );
      // setExpired(expiredData);
      let availableData = newEarnedPoints
        .filter(
          (history) =>
            history.reward_earned_points[0]?.expiry_date === null ||
            moment().isSameOrBefore(
              moment(history.reward_earned_points[0]?.expiry_date)
            )
        )
        .sort((a, b) =>
          moment(a.reward_earned_points[0]?.expiry_date).isBefore(
            moment(b.reward_earned_points[0]?.expiry_date)
          )
            ? 1
            : -1
        );

      let expiredData = newEarnedPoints
        .filter((history) =>
          moment().isAfter(moment(history.reward_earned_points[0]?.expiry_date))
        )
        .sort((a, b) =>
          moment(a.reward_earned_points[0]?.expiry_date).isAfter(
            moment(b.reward_earned_points[0]?.expiry_date)
          )
            ? 1
            : -1
        );
      setAvailable(
        availableData.map((history) => ({
          ...history,
          expiry_date:
            history.reward_earned_points[0]?.expiry_date === null
              ? null
              : moment(history.reward_earned_points[0]?.expiry_date),
        }))
      );
      setExpired(expiredData);
    }
  }, [newEarnedPoints]);

  // useEffect(() => {
  //   fetchSetting();
  // }, []);

  return (
    <div
      className="right-sidebar-menu pb-4"
      style={{ overflowY: 'auto', width: '35%' }}
    >
      <div className="x-button-container">
        <button
          className="x-button"
          onClick={() => setActiveSidebar(!activeSidebar)}
        >
          <img
            src="https://server-mae.manpower.com.sg/public/img/6b5786439c.png"
            alt="x-icon"
          />
        </button>
      </div>
      <div className="sidebar-content">
        <div className="d-flex flex-column">
          <h4>Points Transaction</h4>
          <div className="d-flex justify-content-start mt-4">
            {tabs.map((tab) => (
              <div
                key={tab}
                className="pb-3 flex-shrink-0"
                onClick={() => setActiveTab(tab)}
              >
                <div
                  style={
                    activeTab === tab
                      ? {
                          cursor: 'pointer',
                          marginRight: '1.5rem',
                          paddingBottom: '1rem',
                          marginBottom: '1rem',
                          borderBottom: '5px #466ea5 solid',
                        }
                      : {
                          cursor: 'pointer',
                          marginRight: '1.5rem',
                          paddingBottom: '1rem',
                          marginBottom: '1rem',
                        }
                  }
                >
                  <strong
                    className={activeTab === tab ? 'text-brand' : 'text-muted'}
                  >
                    {tab}
                  </strong>
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex flex-column">
            {activeTab === 'Available' &&
              available.length > 0 &&
              available.map((history, index) => (
                <div
                  key={history.id}
                  className="py-2 px-3 mb-2 border rounded d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex flex-column">
                    <h3>{history.points}</h3>
                    <small>POINTS</small>
                  </div>
                  <div className="d-flex flex-column flex-grow-1 ps-3">
                    <div className="d-flex mb-3 justify-content-between align-items-center">
                      <strong>{history.reason.reason}</strong>
                      {history.remarks && (
                        <>
                          <i
                            className="fas fa-info-circle text-brand"
                            data-tip
                            data-for={`history-${index}`}
                          ></i>
                          <ReactTooltip id={`history-${index}`}>
                            <span>{history.remarks}</span>
                          </ReactTooltip>
                        </>
                      )}
                    </div>
                    {/* <small className="text-muted">Used Points: 0</small> */}
                    {history.expiry_date === null ? (
                      <small className="text-muted">
                        Credit rewards no expiry
                      </small>
                    ) : (
                      <small className="text-muted">
                        EXP: {moment(history.expiry_date).format('D MMMM YYYY')}
                      </small>
                    )}
                    <small className="text-muted">
                      By:{' '}
                      {history.admin
                        ? `${history.admin.first_name} ${history.admin.last_name}`
                        : history.supervisor
                        ? `${history.supervisor.first_name} ${history.supervisor.last_name}`
                        : 'Admin'}
                    </small>
                  </div>
                </div>
              ))}
            {activeTab === 'Expired' &&
              available.length > 0 &&
              expired.map((history, index) => (
                <div
                  key={history.id}
                  className="py-2 px-3 mb-2 border rounded d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex flex-column">
                    <h3>{history.points}</h3>
                    <small>POINTS</small>
                  </div>
                  <div className="d-flex flex-column flex-grow-1 ps-3">
                    <div className="d-flex mb-3 justify-content-between align-items-center">
                      <strong>{history.reason.reason}</strong>
                      {history.remarks && (
                        <>
                          <i
                            className="fas fa-info-circle text-brand"
                            data-tip
                            data-for={`history-${index}`}
                          ></i>
                          <ReactTooltip id={`history-${index}`}>
                            <span>{history.remarks}</span>
                          </ReactTooltip>
                        </>
                      )}
                    </div>
                    <small className="text-muted">Expired</small>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardsSidebar;
